module.exports = __webpack_public_path__ + "static/media/main.eb6e949b.png";